import React from 'react';

const XIcon14pxSvg = (props) => {
   return (
      <svg {...props} xmlns='http://www.w3.org/2000/svg' width='14' height='15' viewBox='0 0 14 15' fill='none'>
         <path
            fillRule='evenodd'
            clipRule='evenodd'
            d='M12.1223 2.39313C12.163 2.43377 12.1953 2.48205 12.2174 2.5352C12.2394 2.58835 12.2508 2.64533 12.2508 2.70288C12.2508 2.76042 12.2394 2.8174 12.2174 2.87056C12.1953 2.92371 12.163 2.97199 12.1223 3.01263L2.49725 12.6376C2.4151 12.7198 2.30368 12.7659 2.1875 12.7659C2.07132 12.7659 1.9599 12.7198 1.87775 12.6376C1.7956 12.5555 1.74945 12.4441 1.74945 12.3279C1.74945 12.2117 1.7956 12.1003 1.87775 12.0181L11.5028 2.39313C11.5434 2.35238 11.5917 2.32006 11.6448 2.298C11.698 2.27595 11.755 2.2646 11.8125 2.2646C11.8701 2.2646 11.927 2.27595 11.9802 2.298C12.0333 2.32006 12.0816 2.35238 12.1223 2.39313Z'
            fill='currentColor'
         />
         <path
            fillRule='evenodd'
            clipRule='evenodd'
            d='M1.87774 2.39313C1.837 2.43377 1.80467 2.48205 1.78262 2.5352C1.76056 2.58835 1.74921 2.64533 1.74921 2.70288C1.74921 2.76042 1.76056 2.8174 1.78262 2.87056C1.80467 2.92371 1.837 2.97199 1.87774 3.01263L11.5027 12.6376C11.5849 12.7198 11.6963 12.7659 11.8125 12.7659C11.9287 12.7659 12.0401 12.7198 12.1222 12.6376C12.2044 12.5555 12.2505 12.4441 12.2505 12.3279C12.2505 12.2117 12.2044 12.1003 12.1222 12.0181L2.49724 2.39313C2.4566 2.35238 2.40832 2.32006 2.35517 2.298C2.30202 2.27595 2.24504 2.2646 2.18749 2.2646C2.12994 2.2646 2.07296 2.27595 2.01981 2.298C1.96666 2.32006 1.91838 2.35238 1.87774 2.39313Z'
            fill='currentColor'
         />
      </svg>
   );
};

export default XIcon14pxSvg;
